import type { MarketCredentialWithConnectionStatus } from '@talos/kyoko';
import { useConnectionStatusContext, useObservableValue } from '@talos/kyoko';
import { computeNumConnectedMarkets } from '../../../utils/status';

export function useNumConnected() {
  const { marketCredentialsWithConnectionStatusByCredentialID } = useConnectionStatusContext();
  const marketCredentialsWithStatus = [
    ...useObservableValue(
      () => marketCredentialsWithConnectionStatusByCredentialID,
      [marketCredentialsWithConnectionStatusByCredentialID],
      new Map<number, MarketCredentialWithConnectionStatus>()
    ).values(),
  ];
  return computeNumConnectedMarkets(marketCredentialsWithStatus);
}
